import { ADMIN, CUSTOMER, CUSTOMER_EXPERIENCE, DEVELOPER, QUALITY_ASSURANCE } from "entities/user/role";
import useRole from "hooks/useRole";
import { DefaultPermission } from "utils/permission";

export default function useUsersPermissions(): DefaultPermission {
  const { hasRole, hasNotRole } = useRole()

  return {
    canCreate: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE),
    canEdit: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE),
    canDelete: hasRole(ADMIN, DEVELOPER, QUALITY_ASSURANCE),
    canList: hasNotRole(CUSTOMER),
    canShow: hasNotRole(CUSTOMER)
  }
}
